import { motion } from 'framer-motion'
import { Flame, MessageCircle, Brain, CheckCircle, AlertTriangle } from 'lucide-react'
import FeatureLayout from '../../components/FeatureLayout'
import { useLanguage } from '../../contexts/LanguageContext'

export default function RoastModePage() {
  const { t } = useLanguage()

  const exampleRoasts = [
    t('roast.modal.example1'),
    t('roast.modal.example2'),
    t('roast.modal.example3'),
    t('roast.modal.example4'),
  ]

  return (
    <FeatureLayout
      title={t('roast.modal.title')}
      subtitle={t('roast.modal.subtitle')}
      gradientFrom="from-orange-500"
      gradientTo="to-red-500"
      icon={<Flame className="h-10 w-10 text-white" />}
      featureName="Roast Mode"
    >
      {/* What Is Section */}
      <section className="mb-16">
        <div className="bg-gradient-to-r from-orange-500/10 to-red-500/10 rounded-3xl p-8 lg:p-12 border border-orange-500/20">
          <div className="flex items-start gap-6">
            <div className="p-4 bg-orange-500/20 rounded-2xl">
              <Brain className="h-8 w-8 text-orange-400" />
            </div>
            <div>
              <h2 className="text-3xl font-bold text-white mb-4">{t('roast.modal.whatIs')}</h2>
              <p className="text-gray-300 text-lg leading-relaxed">{t('roast.modal.intro')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Example Roasts */}
      <section className="mb-16">
        <h2 className="text-3xl font-bold text-white mb-8">{t('roast.modal.exampleRoasts')}</h2>

        <div className="space-y-4">
          {exampleRoasts.map((roast, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1,x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="bg-gradient-to-r from-orange-500/10 to-red-500/10 rounded-2xl p-6 border border-orange-500/20 flex items-start gap-4"
            >
              <MessageCircle className="h-6 w-6 text-orange-400 flex-shrink-0 mt-1" />
              <p className="text-gray-300 italic text-lg">{roast}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Warning */}
      <section className="mb-16">
        <div className="bg-yellow-500/10 rounded-2xl p-6 border border-yellow-500/30 flex items-start gap-4">
          <AlertTriangle className="h-6 w-6 text-yellow-400 flex-shrink-0 mt-1" />
          <div>
            <h3 className="text-xl font-bold text-white mb-2">{t('roast.modal.warning')}</h3>
            <p className="text-gray-300 mb-3">{t('roast.modal.warningText')}</p>
            <p className="text-gray-400 text-sm">{t('roast.modal.switchBack')}</p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section>
        <div className="bg-gradient-to-r from-orange-600/20 to-red-600/20 rounded-3xl p-8 lg:p-12 border border-orange-500/30 text-center">
          <CheckCircle className="h-16 w-16 text-orange-400 mx-auto mb-6" />
          <h2 className="text-3xl font-bold text-white mb-4">{t('roast.modal.cta')}</h2>
          <p className="text-gray-300 text-lg mb-8 max-w-2xl mx-auto">
            {t('roast.modal.ctaDescription')}
          </p>
          <a
            href="/#waitlist"
            className="inline-block px-8 py-4 bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white font-semibold rounded-xl transition-all transform hover:scale-105"
          >
            Join Waitlist Now
          </a>
        </div>
      </section>
    </FeatureLayout>
  )
}
